import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Navbar from './Components/Navbar'
import About from './Components/About'
import Service from './Components/Service'
import Feature from './Components/Feature'
import CalltoAction from './Components/CalltoAction'
import Portfolio from './Components/Portfolio'
import Testimonials from './Components/Testimonials'
import Team from './Components/Team'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
import ServiceDetails from './Pages/ServiceDetails';
import HotelService from './Pages/HotelService';
import CateringService from './Pages/CateringService';
import ItService from './Pages/ItService';
import TradingService from './Pages/TradingService';
import BuildingService from './Pages/BuildingService';
import FoodStore from './Pages/FoodStore';
import PlasticAndCosmestics from './Pages/PlasticAndCosmestics';



function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, [])
  return (
    <div>
      <Router>
      <Navbar />
      <Routes>
          <Route path="/" element={ 
            <>
             <About />
     <Service />
      <Feature />
      <CalltoAction />
      <Portfolio />
      <Testimonials />
      <Team />
      <Contact />
      <Footer />
      
            </>
          } />
          <Route path="/service-details" element={<ServiceDetails />} />
          <Route path="/hotel-service" element={<HotelService />} />
          <Route path="/catering-service" element={<CateringService />} />
          <Route path="/it-service" element={<ItService />} />
          <Route path="/trading-service" element={<TradingService />} />
          <Route path="/building-service" element={<BuildingService />} />
          <Route path='/food-store' element={<FoodStore />} />
          <Route path='/plastic-and-cosmestics' element={<PlasticAndCosmestics />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App
